module.exports = __webpack_public_path__ + "static/media/03-banner-01-santa-fe-mobile@2x.b345ee4d.jpg";